import axios from "axios";

export const getAllUser = async (
  page,
  search,
  filter,
  limit,
  preferred_Language
) => {
  const res = await axios.get(
    `${process.env.REACT_APP_API_URL}/users/get-all`,
    {
      params: { page, search, filter, limit, preferred_Language },
    }
  );
  return res.data;
};

export const featchPromoPlan = async () => {
  try {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/coin-plan-promo/getpromo-plans`,
      headers: {},
    };

    const response = await axios.request(config);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllPromocode = async () => {
  try {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/promocode/get-all-promo-codes`,
      headers: {},
    };

    const response = await axios.request(config);
    // console.log("response.data", response.data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllAccDeleteReq = async (
  page = 1,
  limit = 6,
  filterOption = "All Request"
) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/account-delete/get-all`,
      {
        params: { page, limit, filterOption },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error in getAllAccDeleteReq:", error.message);
    throw new Error("Failed to fetch account delete requests");
  }
};

export const getAccDeleteStats = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/account-delete/account-delete-stats`
    );
    return response.data;
  } catch (error) {
    console.error("Error in getAccDeleteStats:", error.message);
    throw new Error("Failed to fetch account delete statistics");
  }
};

export const getAllEmojis = async () => {
  try {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/emoji-package/get-emoji-packages-admin?isAdmin=true`,
      headers: {},
    };

    const response = await axios.request(config);
    // console.log("emoji data", response.data);
    return response.data;
  } catch (error) {
    throw error;
  }
};
